module.exports = __webpack_public_path__ + "static/media/ganzhi.7a5fb7c1.png";